// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAWRILmldcyBEmp_g-SpgTnjld7S0yY_r8",
  authDomain: "pushnotifcations-d9a0e.firebaseapp.com",
  projectId: "pushnotifcations-d9a0e",
  storageBucket: "pushnotifcations-d9a0e.appspot.com", // ✅ تم التصحيح هنا
  messagingSenderId: "632094263132",
  appId: "1:632094263132:web:88ec7ddcd4e0fba05c2399",
  measurementId: "G-QQ3KGE7LVM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

// ✅ توليد التوكن عند قبول الإشعار
export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  console.log("Notification permission:", permission);

  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey: "BPQ8Le71QyE7OVaMtJa8epPTsw6AlzCSzTRE9KUPvf9HtuabCOVfleq2q22fJr-2e_rfQ79GG8oslewFvzRTSMc"
    });
    console.log("FCM Token generated successfully");
  }
};

export { messaging };
